/*
* @描述: 选择产品弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/17 09:43
*/
<template>
  <van-popup v-model.sync="dialogVisible"
             :style="{ width: '100%',height: '100%' }">
    <div v-loading="loading" class="public_container">
      <div class="returnNavBar">
        <ReturnNavBar :isAllFunctions="false"
                      :isCustomReturnEvent="true"
                      :isTitleNormal="true"
                      title="返回"
                      @returnEvent="handleDialogClose">
        </ReturnNavBar>
        <div class="returnNavBarRight">
          <el-input ref="keyword_input"
                    v-model="product_name"
                    class="keyword_input"
                    placeholder="请输入产品名称"
                    prefix-icon="el-icon-search"
                    size="small"
                    style="width: 144px"
                    @blur="getProductList"
                    @keyup.enter.native="handleClickSearch"></el-input>
        </div>
      </div>
      <div class="category_list_wrap flex_wrap" @click="showCategoryPicker=true">
        <span class="category_name" v-text="categoryName"></span>
        <i :class="showCategoryPicker?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
      </div>
      <ul class="product_list_wrap">
        <li v-for="item in productList" class="product_item">
          <div class="flex_wrap">
            <img
                :src="item.image&&item.image.length?item.image[0]:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                alt=""
                class="product_image">
            <div class="goods_name" v-text="item.goods_name"></div>
          </div>
          <el-button plain
                     size="mini"
                     type="primary"
                     @click="handleClickChooseProductConfig(item)">选择
          </el-button>
        </li>
      </ul>
      <div class="select_product_footer">
        <div class="flex_wrap">
          <img alt=""
               class="shopping_cart_icon" src="https://download.hecoos.com/enlightv/2025-11/6fd0a06866199d2e5212a6f00f212ac2.png">
          <div class="total_price_wrap flex_wrap">
            <div>
              <span class="total_price_label">总价：</span>
              <span class="total_price_value" v-text="'¥'+goodsTotalPrice"></span>
              <span class="total_price_label">元</span>
            </div>
            <i v-if="selectedProductList.length" class="el-icon-caret-top"
               @click="selectedItemsVisible=true"></i>
          </div>
        </div>
        <el-button size="small" type="primary" @click="handleClickSubmit">提交</el-button>
      </div>
    </div>
    <ProductConfigDialog v-if="productConfigDialogVisible"
                         :dialogVisible.sync="productConfigDialogVisible"
                         :goods_id="goods_id"
                         :product_type="product_type"
                         :source="source"
                         @submit="handleGetProductConfig"/>
    <van-popup v-if="selectedItemsVisible"
               v-model.sync="selectedItemsVisible"
               :style="{ width: '100%'}"
               position="bottom"
               round>
      <div class="popup_title_wrap">
        <span class="popup_title">已选产品</span>
        <van-icon name="cross" @click="selectedItemsVisible=false"/>
      </div>
      <ul class="selected_items_list">
        <li v-for="(row,index) in selectedProductList" class="selected_items_item">
          <div class="flex_js_wrap">
            <img
                :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                alt=""
                class="product_image">
            <div style="flex: 1">
              <div class="flex_js_wrap">
                <span class="goods_name" v-text="row.goods_name"></span>
                <van-icon name="clear" @click="handleClickRemoveSelected(index)"/>
              </div>
              <div class="flex_js_wrap">
                <div>
                  <span class="goods_price" v-text="'￥'+row.price.value"></span>
                  <span class="goods_unit" v-text="row.unit?'/'+row.unit:'/个'"></span>
                </div>
                <div class="goods_count_wrap">
                  <el-input-number v-model="row.num"
                                   :min="1"
                                   size="mini"
                                   @change="handleGoodsNumChange(item)"></el-input-number>
                </div>
              </div>
            </div>
          </div>
          <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
            <ul class="goods_spec_list">
              <template v-if="row.is_expand">
                <li v-for="child in row._child"
                    :key="child.part_id"
                    class="good_part_item"
                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                </li>
              </template>
              <template v-else>
                <li v-for="child in row._child.slice(0,1)"
                    :key="child.part_id"
                    class="good_part_item"
                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                </li>
              </template>
            </ul>
            <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                            <span class="handle_expand_text"
                                  v-text="row.is_expand?'收起配置':'展开配置'"></span>
              <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                 class="iconfont"></i>
            </div>
          </div>
        </li>
      </ul>
    </van-popup>
    <van-overlay v-if="showCategoryPicker"
                 :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}"
                 :show="showCategoryPicker"
                 class-name="category_overlay">
      <div class="category_wrap">
        <div :class="{'active':categoryId===0}" class="all_goods"
             @click="handleClickCategoryNode({id:0,name:''})">全部产品
        </div>
        <div :class="{'noActiveTree':categoryId === 0}">
          <el-tree ref="categoryList"
                   :current-node-key="categoryId"
                   :data="categoryList"
                   :expand-on-click-node='false'
                   :props="{children: 'children',label: 'name'}"
                   check-on-click-node
                   check-strictly
                   default-expand-all
                   highlight-current
                   node-key="id"
                   @node-click="handleClickCategoryNode">
            <div slot-scope="{ node, data }" class="custom_tree_node">
              <div class="node_label ellipsis">
                <EllipsisTooltip :text="node.label"></EllipsisTooltip>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </van-overlay>
  </van-popup>
</template>
<script>
import {GetProductList, GoodsCategoryList, GoodsList} from "@/api";
import EllipsisTooltip from '@/components/pComponents/ellipsisTooltip';
import {pagination} from "@/mixins";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import ProductConfigDialog from "@/components/mComponents/ProductConfigDialog.vue";

export default {
  name: "selectOrderProducts",
  data() {
    return {
      product_name: '',
      loading: false,
      categoryList: [],
      categoryId: 0,
      categoryName: '全部产品',
      productList: [],
      selectedProductList: [],
      // selectedProductList: [
      //     {
      //         "type": 1,
      //         "goods_id": 51,
      //         "goods_name": "水果大礼包礼盒（套）",
      //         "goods_type": "bundle",
      //         "goods_sku_id": 0,
      //         "sku_key": "",
      //         "goods_sku_name": "水果大礼包礼盒（套）",
      //         "start_at": "",
      //         "end_at": "",
      //         "cost_price": "2110.00",
      //         "guide_price": "6630.00",
      //         "sale_guide_price": "6630.00",
      //         "lease_guide_price": "4810.00",
      //         "price": {
      //             "value": "6630.00",
      //             "text": "6630.00",
      //             "currency": "CNY",
      //             "value_converted": "6630.00"
      //         },
      //         "num": 1,
      //         "subtotal_price": {
      //             "value": 6630,
      //             "text": "6,630.00",
      //             "currency": "CNY",
      //             "value_converted": 6630
      //         },
      //         "unit": "",
      //         "is_virtual": 1,
      //         "goods_image": "",
      //         "is_sale": 1,
      //         "is_lease": 1,
      //         "description": "水果大礼包礼盒",
      //         "_child": [
      //             {
      //                 "type": 1,
      //                 "goods_id": 51,
      //                 "goods_name": "水果",
      //                 "goods_type": "stock",
      //                 "goods_sku_id": 63,
      //                 "sku_key": "",
      //                 "goods_sku_name": "西红柿（可用）",
      //                 "part_id": 11,
      //                 "part_name": "水果",
      //                 "start_at": "",
      //                 "end_at": "",
      //                 "cost_price": "110.00",
      //                 "guide_price": "3130.00",
      //                 "num": 1,
      //                 "price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "subtotal_price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "unit": "",
      //                 "is_virtual": 1
      //             },
      //             {
      //                 "type": 1,
      //                 "goods_id": 51,
      //                 "goods_name": "水果手机",
      //                 "goods_type": "basic",
      //                 "goods_sku_id": 1,
      //                 "sku_key": "1,3",
      //                 "goods_sku_name": "手机-小米-白色-64G",
      //                 "part_id": 12,
      //                 "part_name": "水果手机",
      //                 "start_at": "",
      //                 "end_at": "",
      //                 "cost_price": "1000.00",
      //                 "guide_price": "1500.00",
      //                 "num": 1,
      //                 "price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "subtotal_price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "unit": "台",
      //                 "is_virtual": 1
      //             },
      //             {
      //                 "type": 1,
      //                 "goods_id": 51,
      //                 "goods_name": "水果电脑",
      //                 "goods_type": "basic",
      //                 "goods_sku_id": 7,
      //                 "sku_key": "6,7",
      //                 "goods_sku_name": "电脑3",
      //                 "part_id": 13,
      //                 "part_name": "水果电脑",
      //                 "start_at": "",
      //                 "end_at": "",
      //                 "cost_price": "1000.00",
      //                 "guide_price": "2000.00",
      //                 "num": 1,
      //                 "price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "subtotal_price": {
      //                     "value": 0,
      //                     "text": 0,
      //                     "currency": "CNY",
      //                     "value_converted": 0
      //                 },
      //                 "unit": "台",
      //                 "is_virtual": 1
      //             }
      //         ]
      //     },
      //     {
      //         "type": 1,
      //         "goods_id": 47,
      //         "goods_name": "西红柿（可用）",
      //         "goods_type": "stock",
      //         "goods_sku_id": 63,
      //         "sku_key": "",
      //         "goods_sku_name": "",
      //         "start_at": "",
      //         "end_at": "",
      //         "cost_price": "110.00",
      //         "guide_price": "3130.00",
      //         "lease_guide_price": "310.00",
      //         "sale_guide_price": "3130.00",
      //         "price": {
      //             "value": "3130.00",
      //             "text": "3130.00",
      //             "currency": "CNY",
      //             "value_converted": "3130.00"
      //         },
      //         "num": 1,
      //         "subtotal_price": {
      //             "value": 3130,
      //             "text": "3,130.00",
      //             "currency": "CNY",
      //             "value_converted": 3130
      //         },
      //         "unit": "",
      //         "is_virtual": 1,
      //         "goods_image": "",
      //         "is_sale": 1,
      //         "is_lease": 1,
      //         "description": "水果大礼包礼盒"
      //     },
      //     {
      //         "type": 1,
      //         "goods_id": 2,
      //         "goods_name": "电脑",
      //         "goods_type": "basic",
      //         "goods_sku_id": 5,
      //         "sku_key": "5,7",
      //         "goods_sku_name": "电脑1",
      //         "start_at": "",
      //         "end_at": "",
      //         "cost_price": "1000.00",
      //         "guide_price": "2000.00",
      //         "lease_guide_price": "2500.00",
      //         "sale_guide_price": "2000.00",
      //         "price": {
      //             "value": "2000.00",
      //             "text": "2000.00",
      //             "currency": "CNY",
      //             "value_converted": "2000.00"
      //         },
      //         "num": 1,
      //         "subtotal_price": {
      //             "value": 2000,
      //             "text": "2,000.00",
      //             "currency": "CNY",
      //             "value_converted": 2000
      //         },
      //         "unit": "台",
      //         "is_virtual": 1,
      //         "goods_image": "https://download.hecoos.com/enlightv/2025-03/024dbeffd3f4fe9661a597360d604293.jpg",
      //         "is_sale": 1,
      //         "is_lease": 1,
      //         "description": "1111111111111111111111111111111111111111111111111111111111111111111111"
      //     },
      //     {
      //         "type": 1,
      //         "goods_id": 1,
      //         "goods_name": "手机",
      //         "goods_type": "basic",
      //         "goods_sku_id": 1,
      //         "sku_key": "1,3",
      //         "goods_sku_name": "手机-小米-白色-64G",
      //         "start_at": "",
      //         "end_at": "",
      //         "cost_price": "1000.00",
      //         "guide_price": "1500.00",
      //         "lease_guide_price": "2000.00",
      //         "sale_guide_price": "1500.00",
      //         "price": {
      //             "value": "1500.00",
      //             "text": "1500.00",
      //             "currency": "CNY",
      //             "value_converted": "1500.00"
      //         },
      //         "num": 1,
      //         "subtotal_price": {
      //             "value": 1500,
      //             "text": "1,500.00",
      //             "currency": "CNY",
      //             "value_converted": 1500
      //         },
      //         "unit": "台",
      //         "is_virtual": 1,
      //         "goods_image": "https://download.hecoos.com/enlightv/2024-43/c73350a32956fbe8fca6e9da9ac21198.svg",
      //         "is_sale": 1,
      //         "is_lease": 1,
      //         "description": "手机手机手机手机手机"
      //     }
      // ],
      productConfigDialogVisible: false,
      product_type: '',
      goods_id: '',
      selectedItemsVisible: false,
      showCategoryPicker: false,
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: 'order'
    }
  },
  mixins: [pagination],
  created() {
    this.loading = true
    this.getCategoryList()
  },
  components: {
    ProductConfigDialog,
    EllipsisTooltip,
    ReturnNavBar
  },
  computed: {
    goodsTotalPrice() {
      let totalPrice = this.selectedProductList.reduce((total, item) => {
        return total + Number(item.subtotal_price.value)
      }, 0)
      return totalPrice.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  },
  mounted() {
  },
  methods: {
    handleDialogClose() {
      this.$emit('update:dialogVisible', false)
    },

    handleClickSearch() {
      this.$refs.keyword_input.blur()
    },

    //获取产品分组
    getCategoryList(keyword) {
      GoodsCategoryList({
        keyword: keyword
      }).then(res => {
        if (res.code === 200) {
          this.categoryList = this.removeEmptyGroups(res.data)
          this.getProductList()
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },

    removeEmptyGroups(data) {
      // 过滤每个节点
      return data.map(item => {
        // 递归处理子元素
        item.children = this.removeEmptyGroups(item.children);
        return item;
      }).filter(item => item.has_products || item.children.length > 0); // 仅保留有产品或有子组的项
    },

    //点击分类
    handleClickCategoryNode(data) {
      this.pagination.pageNum = 1
      this.categoryId = data.id
      this.categoryName = data.name ? data.name : '全部产品'
      this.showCategoryPicker = false
      this.getProductList()
    },

    //获取产品列表
    getProductList() {
      this.loading = true
      GetProductList({
        category_id: this.categoryId,
        keyword: this.product_name,
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      }).then(res => {
        if (res.code === 200) {
          const {list, total} = res.data
          this.productList = list
          this.pagination.total = total
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },

    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getProductList()
    },

    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getProductList()
    },

    //点击选择产品获取配置
    handleClickChooseProductConfig(item) {
      this.product_type = item.type
      this.goods_id = item.goods_id
      this.productConfigDialogVisible = true
    },

    handleGetProductConfig(data) {
      this.selectedProductList.push(data.data)
      if (data.close) {
        this.$emit('send-goods-data', this.selectedProductList)
        this.$emit('update:dialogVisible', false)
      }
    },

    //删除已选的商品
    handleClickRemoveSelected(index) {
      this.selectedProductList.splice(index, 1)
      if (this.selectedProductList.length === 0) {
        this.selectedItemsVisible = false
      }
    },

    //商品数量切换事件
    handleGoodsNumChange(item) {
      const total_amount = item.num * item.price.value
      this.$set(item, 'subtotal_price', {
        value: total_amount,
        text: total_amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        currency: "CNY",
        value_converted: total_amount
      })
    },

    //点击打开组合产品的配置
    handleClickExpandConfig(row) {
      if (row.hasOwnProperty('is_expand')) {
        row.is_expand = !row.is_expand
      } else {
        this.$set(row, 'is_expand', true)
      }
    },

    //点击提交选择的产品
    handleClickSubmit() {
      if (this.selectedProductList.length === 0) return this.$message.error('请选择产品')
      this.$emit('send-goods-data', this.selectedProductList)
      this.$emit('update:dialogVisible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.category_list_wrap {
  padding: 10px 16px;

  .category_name {
    font-weight: bold;
    color: #333;
  }
}

.product_list_wrap {
  flex: 1;
  padding-top: 10px;
  background-color: #F7F8FA;
  max-height: calc(100% - 130px);
  overflow-y: auto;

  .product_item {
    padding: 10px 16px;
    background-color: #FFFFFF;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .product_image {
      width: 46px;
      height: 46px;
      border-radius: 4px;
    }

    .flex_wrap {
      align-items: start;

      .goods_name {
        margin-left: 4px;
        font-weight: 700;
      }
    }
  }
}

.select_product_footer {
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .shopping_cart_icon {
    width: 38px;
    height: 38px;
    margin-right: 8px;
  }

  .total_price_wrap {
    line-height: 22px;

    .total_price_label {
      line-height: 22px;
      color: #666666;
    }

    .total_price_value {
      font-weight: 700;
      line-height: 22px;
      color: #E44144;
    }
  }

  ::v-deep .el-button {
    width: 120px;
  }
}

.selected_items_list {
  max-height: calc(85vh - 56px);
  overflow-y: auto;
  padding: 0 16px 16px;

  .selected_items_item {
    padding: 8px;
    border: 2px solid #EDF0F4;
    border-radius: 6px;
    margin-bottom: 4px;
    width: 100%;

    .product_image {
      width: 44px;
      height: 44px;
      border-radius: 4px;
    }

    .van-icon-clear {
      font-size: 16px;
      color: #BFBFBF;
    }

    .goods_name {
      font-weight: 700;
      line-height: 22px;
      color: #333333;
      margin-bottom: 4px;
    }

    .goods_price {
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      color: #e44144;
    }

    .goods_unit {
      font-size: 12px;
      line-height: 18px;
      color: #999999;
    }

    .goods_count_wrap {
      ::v-deep .el-input--mini {
        width: 100px;
        height: 24px;
        line-height: 24px;

        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
    }

    .goods_spec_wrap {
      display: flex;
      align-items: start;
      gap: 4px;
      margin-top: 4px;

      .handle_expand_btn {
        line-height: 18px;
      }

      .goods_spec_list {
        max-width: calc(100% - 62px);
      }
    }
  }
}

.category_overlay {
  top: 85px;
  height: calc(100% - 85px);

  .category_wrap {
    .all_goods {
      height: 38px;
      line-height: 38px;
      padding: 0 16px;
      cursor: pointer;
      background-color: #FFFFFF;

      &.active {
        color: #2990ff;
        font-weight: 700;
      }
    }

    .custom_tree_node {
      padding-right: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .node_label {
        width: calc(100% - 10px);
        font-size: 14px;
      }
    }

    .el-tree-node__content {
      height: 38px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }

    .el-tree-node__expand-icon {
      color: #333333;

      &.is-leaf {
        color: transparent !important;
      }
    }

    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: rgba(41, 144, 255, 0.16);
      color: #2990ff;
      font-weight: 700;
      border-radius: 6px;
    }

    .noActiveTree {
      .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #FFFFFF;
        color: #666666;
        font-weight: 400;
        border-radius: 6px;
      }
    }
  }
}
</style>